'use strict';

import ready from "./lib/ready";
import promiseIdle from "./lib/promise-idle";
import {delegate, trigger} from "./lib/events";
import ToggleArea from "./lib/ToggleArea";
import focusElement from "./lib/focus-element";
import ModalBehavior from './lib/ToggleArea_ModalBehavior';

ready().then(promiseIdle()).then(function () {

	const area = document.querySelector('.searchmodal');
	const toggle = document.querySelector('.search-toggle');

	if (!area || !toggle) {
		return;
	}

	const close = document.querySelector('.searchmodal__close');

	document.addEventListener('click', delegate('a[href="#search"]', function (e) {
		if (e.target === toggle) {
			return;
		}
		e.preventDefault();
		e.stopImmediatePropagation();
		focusElement.call(toggle, true);
		trigger.call(toggle, 'click');
	}));

	new ToggleArea(area, 'search', [
		new ModalBehavior(toggle, close, {
			closeOnOutsideClick: true,
			outside: document.querySelectorAll('.headnav, .wrapper__main, .footer'),
		})
	]);
});